import { makeStyles, useTheme } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import Divider from '@material-ui/core/Divider';
import MenuIcon from '@mui/icons-material/Menu';
import List from '@material-ui/core/List';
import { AppBar, CssBaseline, Drawer } from '@material-ui/core';
import clsx from 'clsx';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import { useWorkListStateSlice } from '../../pages/WorkListPage/slice';
import { useDispatch, useSelector } from 'react-redux';
import { Logo } from '../NavBar/Logo';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { selectDept, selectLeftMenuOpen } from '../../pages/WorkListPage/slice/selectors';
import { Nav } from '../NavBar/Nav';
import { SignOutButton } from '../../pages/LoginPage/components/LogoutButton';
import { NavigationBuilder } from './navigationBuilder';
import NavSection from './NavbarSection';

const drawerWidth = 320;

// NavSection.propTypes = { classes: PropTypes.any };

function BarAndMenu() {
  const [manusCollapseStatu,setManusCollapseStatu] = useState<boolean[]>(Array(5).fill(false));
  const theme = useTheme();
  const classes = useStyles(theme);
  const open = useSelector(selectLeftMenuOpen);
  const userDept = useSelector(selectDept);
  const worklistAction = useWorkListStateSlice().actions;
  const dispatch = useDispatch();
  // const accessControlState = useAccessControlState();
  const [navBarMenu, setNavBarMenu] = useState<any[]>([]);
  // const navigationState = useNavigationState();
  // const navigationDispatch = useNavigationDispatch();

  const handleDrawerOpen = () => {
    dispatch(worklistAction.updateLeftMenuOpen(true));
  };

  const handleDrawerClose = () => {
    manusCollapseStatu.forEach((el,index)=>{
      manusCollapseStatu[index] = false;
    })
    setManusCollapseStatu(manusCollapseStatu);
    dispatch(worklistAction.updateLeftMenuOpen(false));
  };

  const handleClick = (i) => { 
    manusCollapseStatu[i] = !manusCollapseStatu[i];
    setManusCollapseStatu(manusCollapseStatu);
    dispatch(worklistAction.updateLeftMenuOpen(false));
    dispatch(worklistAction.updateLeftMenuOpen(true));
  };

  const updateNavBar = async () => {
    setNavBarMenu(NavigationBuilder(userDept));
  };

  useEffect(() => {
    updateNavBar();
  }, [userDept]);

  return (
    <>
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position='fixed'
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open,
          })}
        >
          <Toolbar>
            <IconButton
              onClick={handleDrawerOpen}
              className={clsx(classes.menuButton, { [classes.hide]: open })}
            >
              <MenuIcon />
            </IconButton>
            <div className={classes.navBar}>
              <Logo />
              <Nav />
            </div>
          </Toolbar>
        </AppBar>
        <Drawer
          variant='permanent'
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            }),
          }}
        >
          <div className={classes.toolbar}>
            <IconButton onClick={handleDrawerClose} className={classes.iconButton}>
              {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </div>
          <Divider />
          <List className={classes.root}>
            {navBarMenu?.[0]?.children?.map((navSection,index) =>
              navSection && <NavSection 
                item={navSection} 
                key={navSection.id} 
                onClick={() => handleClick(index)} 
                onClick1={() => handleDrawerClose()}  
                isOpen={manusCollapseStatu[index]} 
              />
            )}
            {navBarMenu?.[0] && <SignOutButton />}
          </List>
        </Drawer>
      </div>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    width: '100%',
    maxWidth: 360,
    backgroundColor: '#122230',
    color: theme.palette.primary.contrastText,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: '#122230',
    borderColor: '#38393c',
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
    color: theme.palette.primary.contrastText,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    backgroundColor: '#1E2125',
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  navBar: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  iconButton: {
    color: '#FFF',
  },
}));
export default BarAndMenu;
